import React, { memo, useMemo } from 'react'
import { Formik, Form } from 'formik'
import { LATEST_WEBHOOK_VERSION } from 'src/constants/webhook/constants'
import type { WebhookSubscription } from 'src/interfaces/webhook'
import type {
  WebhookSubscriptionFormMode,
  WebhookSubscriptionFormValues,
} from './WebhookSubscriptionForm.interface'
import { WebhookSubscriptionFormContent } from './WebhookSubscriptionFormContent'
import { webhookSubscriptionFormValidator } from './WebhookSubscriptionForm.validator'

interface Props {
  formId: string
  mode: WebhookSubscriptionFormMode
  subscription: WebhookSubscription | null
  onSubmit(values: WebhookSubscriptionFormValues): void
}

const WebhookSubscriptionFormComponent = ({ formId, mode, subscription, onSubmit }: Props) => {
  const initialValues = useMemo<WebhookSubscriptionFormValues>(() => {
    if (mode === 'edit' && subscription) {
      return {
        callbackUrl: subscription.callbackUrl,
        events: subscription.events,
        webhookVersion: subscription.webhookVersion,
      }
    }

    return {
      callbackUrl: '',
      events: [],
      webhookVersion: LATEST_WEBHOOK_VERSION,
    }
  }, [mode, subscription])

  return (
    <Formik<WebhookSubscriptionFormValues>
      initialValues={initialValues}
      validationSchema={webhookSubscriptionFormValidator}
      enableReinitialize
      onSubmit={onSubmit}
    >
      <Form id={formId}>
        <WebhookSubscriptionFormContent />
      </Form>
    </Formik>
  )
}

export const WebhookSubscriptionForm = memo(WebhookSubscriptionFormComponent)
